import { memo } from 'react';

import { Box } from '@mui/material';
import clsx from 'clsx';
import { v4 as uuidV4 } from 'uuid';

import { IImageUploadField } from 'interfaces/files';

import ThumbnailView from 'components/_basic/FileDropzone/ThumbnailView';

import { IActiveDropzoneProps } from './types';

import styles from './ActiveDropzone.module.scss';

export const ActiveDropzone = memo(
  <T extends IImageUploadField>(props: IActiveDropzoneProps<T>) => {
    const { files, onDelete, isMultiple } = props;

    if (!files.length) {
      return null;
    }
    return (
      <Box className={clsx(isMultiple ? styles.filesList : styles.singleImage)}>
        {files.map((item, i) => (
          <ThumbnailView key={uuidV4()} value={item} onDelete={onDelete ? () => onDelete(i) : undefined} />
        ))}
      </Box>
    );
  },
  (prevProps, nextProps) => {
    if (prevProps.files.length !== nextProps.files.length) {
      return false;
    }

    for (let i = 0; i < prevProps.files.length; i++) {
      const prevFile = prevProps.files[i];
      const nextFile = nextProps.files[i];

      if (prevFile.url !== nextFile.url || prevFile.filename !== nextFile.filename || prevFile.url !== nextFile.url) {
        return false;
      }
    }

    return true;
  },
);
